import React from "react";
import styled from "styled-components/macro";
import imgGreen from "../../assets/img/merch/greenPlush.png";
import imgOrange from "../../assets/img/merch/orangePlush.png";
import imgPink from "../../assets/img/merch/pinkPlush.png";
import imgPurple from "../../assets/img/merch/purplePlush.png";
import imgRed from "../../assets/img/merch/redPlush.png";
import imgTeal from "../../assets/img/merch/tealPlush.png";
import { TABLET_WIDTH, MOBILE_WIDTH } from "../../constants/dims";
import { SHOP_CHECKOUT_URL } from "../../constants/urls";
import { ButtonGreen } from '../shared/Button';

import {loadStripe} from '@stripe/stripe-js';

const Container = styled.section`
  width: 100%;
  position: relative;
  background-color: ${(props) => props.theme.getStarted.backgroundColor};
  color: ${(props) => props.theme.getStarted.text};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Canvas = styled.div`
  max-width: ${TABLET_WIDTH}px;
  padding: 40px 20px;
  box-sizing: border-box;

  & > h2 {
    margin-bottom: -30px;
  }

  & > .row {
    display: flex;
    justify-content: space-evenly;
    margin-top: 60px;
    align-items: center;

    & > img {
      width: auto;
    }
  }
`;

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
`;

const Column = styled.div`
  flex: 1 1 300px;
  min-width: 300px;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 24px;
  padding-right: 20px;
  padding-left: 20px;

  &:last-child {
    margin-bottom: 0;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      padding-left: 0;
    }
  }
`;


const Product = styled.div`
  background-color: #fff;
  padding: 10px 14px 10px 14px;
  position: relative;
  box-shadow: 0px 1px 5px #999;

  & > p {
    color: #333;
    margin-top: 0px;
    margin-bottom: 5px;
  }
  & > h4 {
    color: #000;
    margin-bottom: 0px;
  }
`;

let stripePromise = null;

const Shop = () => {  
    function startPurchase(priceId) {
      fetch(SHOP_CHECKOUT_URL+"?priceId="+priceId)
      .then((response) => response.json())
      .then(async (responseValue) => 
      {
          let publishKey = responseValue["publishKey"];

          if(stripePromise == null) 
          {
            stripePromise = await loadStripe(publishKey);
          }

          let session = responseValue["responseData"];

          // When the customer clicks on the button, redirect them to Checkout.
          const result = await stripePromise.redirectToCheckout({ sessionId: session.id, });

          if (result.error) 
          {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            alert(result.error.message);
          }
      });    
  }

  return (
    <Container>
      <Canvas>
        <h2>Brainquake Merchandise</h2>
      </Canvas>      
      <Columns>
        <Column>
          <Product>
            <h4>Green Plush Wuzzit</h4>
            <div>
              <img
                  src={imgGreen}
                  alt="Select"
                  style={{ width: "100%", height: "100%", marginTop: "10px" }}                  
                />                
            </div>
            <p style={{"fontSize":"30px"}}>$19.99</p>
            <div>
              <ButtonGreen 
              style={{"fontSize": "20px"}}
              onClick={() => startPurchase("greenWuzzitPriceId")}>
              BUY NOW
              </ButtonGreen>
            </div>
          </Product>
        </Column>

        <Column>
          <Product>
          <h4>Orange Plush Wuzzit</h4>
            <div>
              <img
                  src={imgOrange}
                  alt="Select"
                  style={{ width: "100%", height: "100%", marginTop: "10px" }}
                />
            </div>
            <p style={{"fontSize":"30px"}}>$19.99</p>
            <div>
              <ButtonGreen 
              style={{"fontSize": "20px"}}
              onClick={() => startPurchase("orangeWuzzitPriceId")}>
              BUY NOW
              </ButtonGreen>
            </div>
          </Product>
        </Column>

        <Column>
        <Product>
        <h4>Pink Plush Wuzzit</h4>
            <div>
              <img
                  src={imgPink}
                  alt="Select"
                  style={{ width: "100%", height: "100%", marginTop: "10px" }}
                />
            </div>
            <p style={{"fontSize":"30px"}}>$19.99</p>
            <div>
              <ButtonGreen 
              style={{"fontSize": "20px"}}
              onClick={() => startPurchase("pinkWuzzitPriceId")}>
              BUY NOW
              </ButtonGreen>
            </div>
          </Product>
        </Column>
      </Columns>
      
      <Columns>
        <Column>
          <Product>
          <h4>Purple Plush Wuzzit</h4>
            <div>
              <img
                  src={imgPurple}
                  alt="Select"
                  style={{ width: "100%", height: "100%", marginTop: "10px" }}
                />
            </div>
            <p style={{"fontSize":"30px"}}>$19.99</p>
            <div>
              <ButtonGreen 
              style={{"fontSize": "20px"}}
              onClick={() => startPurchase("purpleWuzzitPriceId")}>
              BUY NOW
              </ButtonGreen>
            </div>
          </Product>
        </Column>

        <Column>
          <Product>
          <h4>Red Plush Wuzzit</h4>
            <div>
              <img
                  src={imgRed}
                  alt="Select"
                  style={{ width: "100%", height: "100%", marginTop: "10px" }}
                />
            </div>
            <p style={{"fontSize":"30px"}}>$19.99</p>
            <div>
              <ButtonGreen 
              style={{"fontSize": "20px"}}
              onClick={() => startPurchase("redWuzzitPriceId")}>
              BUY NOW
              </ButtonGreen>
            </div>
          </Product>
        </Column>

        <Column>
          <Product>
          <h4>Teal Plush Wuzzit</h4>
            <div>
              <img
                  src={imgTeal}
                  alt="Select"
                  style={{ width: "100%", height: "100%", marginTop: "10px" }}
                />
            </div>
            <p style={{"fontSize":"30px"}}>$19.99</p>
            <div>
              <ButtonGreen 
              style={{"fontSize": "20px"}}
              onClick={() => startPurchase("tealWuzzitPriceId")}>
              BUY NOW
              </ButtonGreen>
            </div>
          </Product>
        </Column>
      </Columns>      
    </Container>
  );
};
export default Shop;

